//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import StateSelectorComponent from '../conditional-components/state-selector-component'

//// Carbon Components
import {
    TextInput,
    TextArea,
    Select,
    SelectItem,
    DatePicker,
    DatePickerInput,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalDisciplineHistoryDeniedComponent = ({
    number,
    handleData,
    handleSubtractAdditionalDisciplineHistoryForm,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const digital_sub_name = 'denied'

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return

    return (
        <>
            <div>
                <h4>Additional Discipline (Denied):</h4>

                <TextInput
                    className="required"
                    labelText="Name of Agency:"
                    id={`RSD34A` + number}
                    name={`RSD34A` + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD34A` + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD34A` + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD34A` + number + 'ErrMsg'
                        ]
                    }
                />

                <StateSelectorComponent
                    digital_name={digital_name}
                    digital_sub_name={digital_sub_name}
                    value_key={['STATEA' + number]}
                    country=""
                />

                <DatePicker
                    className="required"
                    dateFormat="m/d/Y"
                    datePickerType="single"
                    onChange={(e) => handleData(e, ['RSD36A' + number])}
                    onClose={(e) => handleData(e, ['RSD36A' + number])}
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD36A` + number
                        ]
                    }
                >
                    <DatePickerInput
                        className="required"
                        labelText="Action Date:"
                        id={`RSD36A` + number}
                        name={`RSD36A` + number}
                        placeholder="MM/DD/YYYY"
                        type="text"
                        invalid={
                            formsData?.[digital_name]?.[digital_sub_name]
                                ?.errors?.[`RSD36A` + number]
                        }
                        invalidText={
                            formsData?.[digital_name]?.[digital_sub_name]
                                ?.errors?.[`RSD36A` + number + 'ErrMsg']
                        }
                    />
                </DatePicker>

                <TextInput
                    className="required"
                    labelText="Final Action:"
                    id={`FIN_ACTA` + number}
                    name={`FIN_ACTA` + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            `FIN_ACTA` + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `FIN_ACTA` + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `FIN_ACTA` + number + 'ErrMsg'
                        ]
                    }
                />

                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD39A` + number
                        ]
                    }
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD39A` + number
                        ]
                    }
                    helper=""
                    labelText="Under Appeal:"
                    id={`RSD39A` + number}
                    name={`RSD39A` + number}
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD39A` + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD39A` + number + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Yes" value="Y" />
                    <SelectItem text="No" value="N" />
                    <SelectItem text="No Answer" value="NA" />
                </Select>

                <TextArea
                    className="required"
                    labelText="Applicant Statement:"
                    id={`LIC_NTSA` + number}
                    name={`LIC_NTSA` + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            `LIC_NTSA` + number
                        ]
                    }
                    maxLength="4000"
                    type="textarea"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `LIC_NTSA` + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            `LIC_NTSA` + number + 'ErrMsg'
                        ]
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            name={number}
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={
                                handleSubtractAdditionalDisciplineHistoryForm
                            }
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdditionalDisciplineHistoryDeniedComponent
